import {kSystemIcons} from "../../constants/icons";

export default function SystemKnowledgeFrameTitle() {
    // Used in SystemQuestionKnowledge to display
    // Knowledge border title in desktop, tablet and mobile modes

    // BUILD
    return (
        <div className={"absolute -top-[12px] right-[14px] flex space-x-[6px] justify-start items-center px-[8px] text-greyLight5 font-medium bg-backgroundLight3"}>
            <i className="material-icons text-[20px]">
                {kSystemIcons.heart}
            </i>
            <span className={"text-[14px]"}>
                {"Connaissance"}
            </span>
        </div>
    );
}